import { createSlice } from "@reduxjs/toolkit";

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    orders: [],
    selectedOrder: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      totalPages: 1,
      total: 0,
    },
    stats: {
      total: 0,
      pending: 0,
      completed: 0,
      cancelled: 0,
    },
  },
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    addOrder: (state, action) => {
      state.orders.unshift(action.payload);
    },
    updateOrder: (state, action) => {
      const index = state.orders.findIndex((o) => o._id === action.payload._id);
      if (index !== -1) {
        state.orders[index] = action.payload;
      }
    },
    deleteOrder: (state, action) => {
      state.orders = state.orders.filter((o) => o._id !== action.payload);
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setOrdersLoading: (state, action) => {
      state.loading = action.payload;
    },
    setOrdersError: (state, action) => {
      state.error = action.payload;
    },
    setOrdersPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setOrdersStats: (state, action) => {
      state.stats = { ...state.stats, ...action.payload };
    },
    clearOrdersState: (state) => {
      state.orders = [];
      state.selectedOrder = null;
      state.loading = false;
      state.error = null;
      state.pagination = { page: 1, totalPages: 1, total: 0 };
    },
  },
});

export const {
  setOrders,
  addOrder,
  updateOrder,
  deleteOrder,
  setSelectedOrder,
  setOrdersLoading,
  setOrdersError,
  setOrdersPagination,
  setOrdersStats,
  clearOrdersState,
} = ordersSlice.actions;

export default ordersSlice.reducer;
